import React, { type FC } from 'react';
import VerificationInput from 'react-verification-input';
import classNames from 'classnames';

import styles from './VerificationCode.module.scss';

export type VerificationCodeProps = {
  value: string;
  length?: number;
  onComplete?: (value: string) => void;
  onChange?: (value: string) => void;
  onFocus?: () => void;
  placeholder?: string;
  className?: string;
  autoFocus?: boolean;
  isError?: boolean;
};

export const VerificationCode: FC<VerificationCodeProps> = ({
  value,
  length,
  onComplete,
  onChange,
  onFocus,
  className,
  autoFocus,
  placeholder,
  isError,
}) => {
  return (
    <VerificationInput value={value}
                       length={length}
                       onComplete={onComplete}
                       onChange={onChange}
                       onFocus={onFocus}
                       placeholder={placeholder || ''}
                       classNames={{
                         container: classNames(styles.container, className),
                         character: isError ? styles.characterWithError : styles.character,
                         characterSelected: styles.characterSelected,
                         characterFilled: styles.characterFilled,
                       }}
                       autoFocus={autoFocus} />
  );
};
